// extracted by mini-css-extract-plugin
export default {"button":"custom-button_button__SHOzh","secondary":"custom-button_secondary__hFg1-","danger":"custom-button_danger__6naCO"};